export { default } from './AccountMessagesStatus';



// WEBPACK FOOTER //
// ./app/components/borrowing/accountmessages/AccountMessagesStatus/index.js